export enum ToolbarPositionEnum {
  TOP = 'top',
  RIGHT = 'right',
  ZEN = 'zen'
}

export enum ToolbarFlowEnum {
  GRID = 'grid',
  FLEX = 'flex'
}
